import { defaultClient } from '@api/client';

export const promoteToTitle = ({ id }) => {
  return defaultClient.put(`/postImages/${id}/promoteToTitle`);
};
